<template lang="pug">
  .row
    validation-provider(v-slot="{ errors }" ref="transcript_validation")
      .field
        span.file-upload-button(:class="{ error: errors[0] }")
          button(@click.prevent="triggerFileInput" :disabled="disabled")
            img(
              :src="require('../../images/arrow-up-from-bracket.svg')"
              alt="Upload"
              style="width: 16px; height: 16px; margin-right: 6px;"
            )
            | {{ uploading ? 'Uploading...' : 'Upload File' }}
          input(
            ref="sstFileInput"
            type="file"
            style="display: none"
            multiple
            @change="onFileChange"
          )
          small.file-info png, jpeg, pdf up to 50 MB

      .files-list
        .file-item(v-for="(file, idx) in model_data.attachments" :key="idx")
          span.file-name
            a(@click.prevent="openLink(file)") {{ file }}
          span.icon-trash-cross(@click="removeFile(idx)")

      .error-message(v-if="transcript_virus_found")
        span.error {{ t('app.reports.messages.virus_warning_message') }}
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    model_data: {
      type: Object,
      default: () => ({ attachments: [] })
    }
  },
  data() {
    return {
      allowedTypes: [
        'image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml',
        'application/pdf', 'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ],
      uploading: false,
      transcript_virus_found: false
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.sstFileInput.click();
    },
    onFileChange(event) {
      const files = Array.from(event.target.files || []);
      event.target.value = null;
      const validFiles = files.filter(this.isValidFile);

      if (validFiles.length) {
        this.uploadFiles(validFiles);
      }
    },
    isValidFile(file) {
      const sizeMB = file.size / 1024 / 1024;
      const isValid = this.allowedTypes.includes(file.type) && sizeMB < 50;

      this.transcript_virus_found = !isValid;
      return isValid;
    },
    uploadFiles(files) {
      this.uploading = true;
      const formData = new FormData();

      files.forEach(file => formData.append('files[]', file, file.name));

      this.axios.post('/files', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res.data?.completed) {
          this.model_data.attachments.push(...res.data.filenames);
        }
      }).catch(() => {
        // Optionally show an error message
      }).finally(() => {
        this.uploading = false;
      });
    },
    removeFile(index) {
      this.model_data.attachments.splice(index, 1);
    },
    openLink(file) {
      window.open(`/uploads/${file}`, '_blank');
    }
  }
};
</script>
